export const types = {
  CONTENT_SELECTED: 'HomeSection/CONTENT_SELECTED',
  TOGGLE_MODAL: 'HomeSection/TOGGLE_MODAL',
  TOGGLE_PLAYER: 'HomeSection/TOGGLE_PLAYER',
  WIDGETS_FETCH: 'HomeSection/WIDGETS_FETCH',
  WIDGETS_FETCH_FAILURE: 'HomeSection/WIDGETS_FETCH_FAILURE',
  WIDGETS_FETCH_SUCCESS: 'HomeSection/WIDGETS_FETCH_SUCCESS',
  GET_EPISODE_BY_SERIE: 'HomeSection/GET_EPISODE_BY_SERIE',
  WIDGETS_LOAD_MORE: 'HomeSection/WIDGETS_LOAD_MORE',
  WIDGETS_RESET: 'HomeSection/WIDGETS_RESET',
};

export const TOAST_TEXT = {
  TITLE: 'Content',
  'CS-011': 'You do not have the necessary permissions to view the selected content.',
  'CP-004': 'We are very sorry. There was a problem trying to open content.',
  'CL-001': 'Concurrence denied by server.',
  'CL-002': 'No connection to internet.',
  'CP-006': 'User disconnected.',
  'CP-015': 'An error has occurred on the site. Please, try again.',
  'CP-037': 'You are not logged in. Try to login again.',
  'CP-137': 'You are not logged in. Try to login again.',
  'GE-001': 'This content is no longer available on the actual region at this moment.',
  DEFAULT: 'We are very sorry. There was a problem trying to open content.',
};
